"use client";
import React from "react";
import { useRouter } from "next/navigation";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function BackButton() {
  const router = useRouter();
  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      aria-label="Back"
      onClick={() => router.back()}
      className="shrink-0"
    >
      <ArrowLeft className="h-4 w-4" />
      Back
    </Button>
  );
}

